<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import { resolveVariableConditionSummary } from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: variableName = (data.variableName as string) || 'variable';
	$: operator = (data.operator as string) || 'eq';
	$: variableValue = data.variableValue !== undefined ? String(data.variableValue) : '?';
	$: summary = resolveVariableConditionSummary(data);

	const operatorLabel: Record<string, string> = {
		eq: '=',
		ne: '≠',
		lt: '<',
		gt: '>',
		le: '≤',
		ge: '≥',
	};
</script>

<BaseConditionNode
	{id}
	type="variableCondition"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={summary}
	nodeTypeLabel="Variable check"
	{...$$restProps}
>
	<div class="var-body">
		{#if variableName}
			<div class="var-check">
				<span class="var-name">{variableName}</span>
				<span class="var-op">{operatorLabel[operator] ?? operator}</span>
				<span class="var-val">{variableValue}</span>
			</div>
		{:else}
			<span class="placeholder">Select a variable</span>
		{/if}
	</div>
</BaseConditionNode>

<style>
	.var-body {
		padding: 0.25rem;
	}

	.var-check {
		display: flex;
		align-items: center;
		gap: 6px;
		font-family: 'Courier New', monospace;
		font-size: 0.875rem;
	}

	.var-name {
		color: #f97316;
		font-weight: 600;
	}

	.var-op {
		color: var(--flow-slot-muted, #64748b);
	}

	.var-val {
		color: var(--flow-slot-strong, #111827);
		font-weight: 500;
	}

	.placeholder {
		font-size: 0.8rem;
		color: var(--flow-slot-muted, #64748b);
		font-style: italic;
	}
</style>
